import {remove} from 'lodash';
import {Injectable} from '@angular/core';

@Injectable()
export class ModalService {
    private modals: any[] = [];

    add(modal: any) {
        // add modal to array of active modals
        this.modals.push(modal);
    }

    remove(id: string) {
        // remove modal from array of active modals
        remove(this.modals, (item) => {
            return item.id === id;
        });
    }

    open(id: string) {
        // open modal specified by id
        let modal = this.modals.find((item) => {
            return item.id === id;
        });
        modal.open();
    }

    close(id: string) {
        // close modal specified by id
        let modal = this.modals.find((item) => {
            return item.id === id;
        });
        modal.close();
    }
}






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/modal/modal.service.ts